import { useAllocation } from '../useAllocation';
import { variantExp } from '../../experiments/frontDoorOffer';
import { type AcquisitionOffer, mapAllocationToOffer } from './useFrontDoorOffer';
export const useSupFixOffer = (skip = false) => {
  const {
    data: allocationData,
    loading
  } = useAllocation(skip ? [] : [variantExp]);
  const slimBannerVariant = allocationData?.visitor?.configParams?.find(p => p.name === variantExp.name)?.value || variantExp.fallbackValue;

  // SUP clients are excluded from the offer experiment — always show fixed/$20
  const offer: AcquisitionOffer | null = loading ? null : mapAllocationToOffer('standard');
  return {
    offer,
    slimBannerVariant,
    loading
  };
};